import React, {useRef, useState} from "react";
import {Link as RouterLink, useHistory} from "react-router-dom";
import {useSnackbar} from "notistack";
import {Avatar, Box, ButtonBase, Hidden, makeStyles, Menu, MenuItem, Typography} from "@material-ui/core";
import useAuth from "src/hooks/useAuth";
import {useTranslation} from "react-i18next";
import {URL_TEMPLATES as URL} from "src/urlTemplates";

const useStyles = makeStyles(theme => ({
    avatar: {
        height: 32,
        width: 32,
        marginRight: theme.spacing(1)
    },
    popover: {
        width: 200
    }
}));

const Account = () => {
    const classes = useStyles();
    const history = useHistory();
    const ref = useRef(null);
    const {user, logout} = useAuth();
    const {enqueueSnackbar} = useSnackbar();
    const [isOpen, setOpen] = useState(false);
    const {t} = useTranslation("sections");

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleLogout = async () => {
        try {
            handleClose();
            await logout();
            history.push(URL.APP);
        } catch (err) {
            enqueueSnackbar("Unable to logout", {
                variant: "error"
            });
        }
    };

    return (
        <>
            <Box display="flex" alignItems="center" component={ButtonBase} onClick={handleOpen} ref={ref}>
                <Avatar alt="User" className={classes.avatar} src={user.avatar}/>
                <Hidden smDown>
                    <Typography variant="h6" color="inherit">
                        {user.name}
                    </Typography>
                </Hidden>
            </Box>
            <Menu
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                }}
                keepMounted
                PaperProps={{className: classes.popover}}
                getContentAnchorEl={null}
                anchorEl={ref.current}
                open={isOpen}
            >
                <MenuItem component={RouterLink} to={URL.ACCOUNT}>
                    {t("account.items.myProfile")}
                </MenuItem>
                <MenuItem onClick={handleLogout}>{t("account.items.logOut")}</MenuItem>
            </Menu>
        </>
    );
};

export default Account;
